import { API_V2 } from '../api';
import { SearchType } from './SearchModel';

export interface SearchResult {
	id: string;
	name: string;
	type: SearchResultType;
	rank: number,
}

export enum SearchResultType {
	ANY = 'any',
	COMMUNITY = 'community',
	GROUP = 'group',
	EVENT = 'event',
}

export function search(type: SearchType, resultType: SearchResultType, query: string): Promise<SearchResult[]> {
	return API_V2.get(`/search?query=${query}&type=${type}&filter=${resultType}`)
		.then(({ data }) => data as SearchResult[]);
}
